"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_places_autocomplete_1 = require("react-places-autocomplete");
var react_router_dom_1 = require("react-router-dom");
var inline_loader_1 = __importDefault(require("../../account-v3/components/inline_loader"));
var app_1 = require("../app");
var discount_code_field_1 = __importDefault(require("../components/discount_code_field"));
var error_message_1 = __importDefault(require("../components/error_message"));
var paypal_express_checkout_1 = __importDefault(require("../components/paypal_express_checkout"));
var PlacesAutocompleteOverride_1 = __importDefault(require("../components/PlacesAutocompleteOverride"));
var address_parts_1 = __importDefault(require("../helpers/address_parts"));
var CheckoutCookie = __importStar(require("../helpers/login_redirection"));
var localization_1 = require("../localization");
exports.default = (function (_a) {
    var context = (0, react_1.useContext)(app_1.CheckoutContext);
    var history = (0, react_router_dom_1.useHistory)();
    if (!context)
        return null;
    var shippingAddress = context.shippingAddress, isLoadingRechargeCheckout = context.isLoadingRechargeCheckout, imageUrls = context.imageUrls, setShippingAddress = context.setShippingAddress, country = context.country, isPaypalEnabled = context.isPaypalEnabled, checkoutComplete = context.checkoutComplete, dataLayerPushEvent = context.dataLayerPushEvent, email = context.email, customer = context.customer, setEmail = context.setEmail, defaultMarketingFlag = context.defaultMarketingFlag;
    var vals = Object.assign(shippingAddress || {}, { email: (customer === null || customer === void 0 ? void 0 : customer.email) || email, acceptsMarketing: defaultMarketingFlag });
    var _b = (0, react_hook_form_1.useForm)({ defaultValues: vals, mode: 'onChange' }), handleSubmit = _b.handleSubmit, register = _b.register, errors = _b.errors, setValue = _b.setValue, watch = _b.watch;
    var config = localization_1.LocaleConfig[country];
    var _c = __read((0, react_1.useState)(false), 2), isSubmitting = _c[0], setSubmitting = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), hasFormErrors = _d[0], setHasFormErrors = _d[1];
    var _e = __read((0, react_1.useState)(!!(shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.address1)), 2), showAddressFields = _e[0], setShowAddressFields = _e[1];
    var _f = __read((0, react_1.useState)(shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.address1), 2), streetAddress = _f[0], setStreetAddress = _f[1];
    // Register address outside of JSX to prevent `ref` conflicts with PlacesAutocompleteOverride & React-Hook-Form
    (0, react_1.useEffect)(function () {
        if (checkoutComplete) {
            history.push('/confirmation');
            return;
        }
        register({ name: 'address1', type: 'custom' }, { required: 'Required' });
    }, []);
    var validateForm = function () {
        if (Object.keys(errors).length > 0) {
            setHasFormErrors(true);
        }
    };
    var onSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSubmitting(true);
                    values.country = config.countryName;
                    setEmail(values.email);
                    return [4 /*yield*/, setShippingAddress(values, { email: values.email })];
                case 1:
                    _a.sent();
                    setSubmitting(false);
                    history.push('/payment');
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (address) {
        setValue('address1', address, { shouldDirty: true, shouldValidate: true });
        setStreetAddress(address);
        setShowAddressFields(true);
    };
    var login = function () {
        CheckoutCookie.addCheckoutRedirectionCookie();
        if (window.top)
            window.top.location.href = '/pages/checkout-account#login';
        return false;
    };
    var handleAddressSuggestionSelect = function (address) { return __awaiter(void 0, void 0, void 0, function () {
        var results, addr;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, react_places_autocomplete_1.geocodeByAddress)(address)];
                case 1:
                    results = _a.sent();
                    addr = (0, address_parts_1.default)(results[0]);
                    setValue('address1', addr.address1, { shouldDirty: true, shouldValidate: true });
                    setValue('city', addr.city, { shouldDirty: true, shouldValidate: true });
                    setValue('state', addr.state, { shouldDirty: true, shouldValidate: true });
                    setValue('zip', addr.zip, { shouldDirty: true, shouldValidate: true });
                    setStreetAddress(addr.address1);
                    dataLayerPushEvent('checkout__shippingAddressSuggestionSelected', { city: addr.city, state: addr.state, zip: addr.zip, country: country });
                    return [2 /*return*/];
            }
        });
    }); };
    var googleSearchOptions = {
        componentRestrictions: { country: context.country.toLowerCase() },
        types: ['address'],
    };
    var formValues = watch();
    var fieldContainerClassName = function (key) {
        return (0, classnames_1.default)({ 'form-input': true, 'with-error': errors[key], 'is-filled': !!formValues[key] });
    };
    return (react_1.default.createElement("div", { className: 'padding-bottom-6' },
        isLoadingRechargeCheckout && (react_1.default.createElement("div", { className: 'margin-top-4 padding-2 text-center' },
            react_1.default.createElement(inline_loader_1.default, { isLoading: isLoadingRechargeCheckout, loadingText: "Please wait..." }))),
        react_1.default.createElement("div", null,
            react_1.default.createElement("form", { onSubmit: handleSubmit(onSubmit) }, !isLoadingRechargeCheckout && (react_1.default.createElement(react_1.default.Fragment, null,
                isPaypalEnabled && (react_1.default.createElement("div", { className: 'checkout-express-checkout-container' },
                    react_1.default.createElement("h4", { className: 'h6 express-checkout-title' }, "Express Checkout"),
                    react_1.default.createElement(paypal_express_checkout_1.default, { setSubmitting: setSubmitting }))),
                react_1.default.createElement("h4", { className: 'h4 margin-bottom-6' }, "Contact Information"),
                react_1.default.createElement("div", { className: 'font-lighter font-size-14' }, customer ? (react_1.default.createElement(react_1.default.Fragment, null,
                    "Want to use a different account? ",
                    react_1.default.createElement("a", { onClick: function () { return login(); } }, "Log In"))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    "Already have an account? ",
                    react_1.default.createElement("a", { onClick: function () { return login(); } }, "Log In")))),
                react_1.default.createElement("div", { className: fieldContainerClassName('email') },
                    react_1.default.createElement("div", { className: 'is-required-field' },
                        react_1.default.createElement("label", null,
                            react_1.default.createElement("input", { type: 'text', name: 'email', autoComplete: 'email', spellCheck: false, autoCapitalize: 'off', placeholder: 'Email', disabled: !!customer, ref: register({
                                    required: 'Required',
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: 'Invalid email format',
                                    },
                                }) }),
                            react_1.default.createElement("span", { className: 'placeholder' }, "Email"))),
                    react_1.default.createElement(error_message_1.default, { error: errors.email })),
                react_1.default.createElement("h4", { className: 'h4 margin-bottom-0 margin-top-6' }, "Shipping Address"),
                react_1.default.createElement("div", { className: 'grid-x' },
                    react_1.default.createElement("div", { className: 'cell small-6' },
                        react_1.default.createElement("div", { className: (0, classnames_1.default)(fieldContainerClassName('firstName'), 'padding-right-1 margin-bottom-0') },
                            react_1.default.createElement("div", { className: 'is-required-field' },
                                react_1.default.createElement("label", null,
                                    react_1.default.createElement("input", { type: 'text', name: 'firstName', autoComplete: 'given-name', spellCheck: false, autoCapitalize: 'off', ref: register({
                                            required: {
                                                value: true,
                                                message: 'Name Required',
                                            },
                                        }) }),
                                    react_1.default.createElement("span", { className: 'placeholder' }, "First Name"))),
                            react_1.default.createElement(error_message_1.default, { error: errors.firstName }))),
                    react_1.default.createElement("div", { className: 'cell small-6' },
                        react_1.default.createElement("div", { className: (0, classnames_1.default)(fieldContainerClassName('lastName'), 'padding-left-1 margin-bottom-0') },
                            react_1.default.createElement("div", { className: 'is-required-field' },
                                react_1.default.createElement("label", null,
                                    react_1.default.createElement("input", { name: 'lastName', autoComplete: 'family-name', type: 'text', ref: register({
                                            required: {
                                                value: true,
                                                message: 'Name Required',
                                            },
                                        }) }),
                                    react_1.default.createElement("span", { className: 'placeholder' }, "Last Name")))))),
                react_1.default.createElement("div", { className: fieldContainerClassName('company') },
                    react_1.default.createElement("label", null,
                        react_1.default.createElement("input", { name: 'company', autoComplete: 'company', type: 'text', ref: register({}) }),
                        react_1.default.createElement("span", { className: 'placeholder' }, "Company (Optional)"))),
                react_1.default.createElement("div", { className: fieldContainerClassName('phoneNumber') },
                    react_1.default.createElement("div", { className: 'is-required-field' },
                        react_1.default.createElement("label", null,
                            react_1.default.createElement("input", { name: 'phoneNumber', type: 'tel', autoComplete: 'tel', ref: register({
                                    required: {
                                        value: true,
                                        message: 'Phone number is required',
                                    },
                                    minLength: {
                                        value: 7,
                                        message: 'Phone is too short',
                                    },
                                    maxLength: {
                                        value: 12,
                                        message: 'Phone is too long',
                                    },
                                }) }),
                            react_1.default.createElement("span", { className: 'placeholder' }, "Phone Number"))),
                    react_1.default.createElement(error_message_1.default, { error: errors.phoneNumber })),
                react_1.default.createElement("div", { className: fieldContainerClassName('address1') },
                    react_1.default.createElement("div", { className: 'is-required-field' },
                        react_1.default.createElement("label", null,
                            react_1.default.createElement(PlacesAutocompleteOverride_1.default, { value: streetAddress || '', onChange: handleChange, onSelect: handleAddressSuggestionSelect, searchOptions: googleSearchOptions }, function (_a) {
                                var getInputProps = _a.getInputProps, suggestions = _a.suggestions, getSuggestionItemProps = _a.getSuggestionItemProps, loading = _a.loading;
                                return (react_1.default.createElement(react_1.default.Fragment, { key: 'ac0' },
                                    react_1.default.createElement("input", __assign({ key: 'ac1', autoCapitalize: 'off' }, getInputProps({
                                        name: 'address1',
                                        type: 'text',
                                        autoComplete: 'random',
                                        // For some reason, autoComplete off doesn't always work on Chrome.
                                        // However, making it a random string turns it off.See https://stackoverflow.com/questions/30053167/autocomplete-off-vs-false
                                        placeholder: 'Type to search...',
                                    }))),
                                    react_1.default.createElement("span", { className: 'placeholder', key: 'ac2' }, "Street Address"),
                                    react_1.default.createElement("div", { className: 'autocomplete-dropdown-container', key: 'ac3' },
                                        loading && react_1.default.createElement("div", { className: 'suggestion-item' }, "Loading..."),
                                        suggestions.map(function (suggestion, suggestionIndex) {
                                            var className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                                            var strDisplay = suggestion.description;
                                            if (suggestion.matchedSubstrings.length && suggestion.matchedSubstrings[0]) {
                                                var subStrMatch = suggestion.matchedSubstrings[0];
                                                var match = strDisplay.substr(subStrMatch.offset, subStrMatch.length);
                                                strDisplay = strDisplay.replace(match, "<b>".concat(match, "</b>"));
                                            }
                                            return (react_1.default.createElement("div", __assign({}, getSuggestionItemProps(__assign(__assign({}, suggestion), { id: "sk-".concat(suggestionIndex.toString()) }), {
                                                className: className,
                                            })),
                                                react_1.default.createElement("img", { src: imageUrls.locationMark || '', style: { marginRight: '8px' } }),
                                                react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: strDisplay } })));
                                        }))));
                            }))),
                    react_1.default.createElement(error_message_1.default, { error: errors.address1 })),
                react_1.default.createElement("div", { className: (0, classnames_1.default)({ hide: !showAddressFields }) },
                    react_1.default.createElement("div", { className: fieldContainerClassName('address2') },
                        react_1.default.createElement("label", null,
                            react_1.default.createElement("input", { name: 'address2', autoComplete: 'address-line2', type: 'text', ref: register({}) }),
                            react_1.default.createElement("span", { className: 'placeholder' }, "Suite / Apartment #")),
                        react_1.default.createElement(error_message_1.default, { error: errors.address2 })),
                    react_1.default.createElement("div", { className: fieldContainerClassName('city') },
                        react_1.default.createElement("div", { className: 'is-required-field' },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { name: 'city', type: 'text', autoComplete: 'shipping locality', ref: register({
                                        required: 'Required',
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "City"))),
                        react_1.default.createElement(error_message_1.default, { error: errors.city })),
                    react_1.default.createElement("div", { className: fieldContainerClassName('state') },
                        react_1.default.createElement("div", { className: 'is-required-field' },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("select", { name: 'state', autoComplete: 'shipping region', ref: register({
                                        required: 'Required',
                                    }) },
                                    react_1.default.createElement("option", null, "Select"),
                                    config.states.map(function (state) { return (react_1.default.createElement("option", { key: state.name, value: state.name }, state.name)); })),
                                react_1.default.createElement("span", { className: 'placeholder' }, config.labels.state))),
                        react_1.default.createElement(error_message_1.default, { error: errors.state })),
                    react_1.default.createElement("div", { className: fieldContainerClassName('zip') },
                        react_1.default.createElement("div", { className: 'is-required-field' },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { name: 'zip', type: 'text', autoComplete: 'shipping postal-code', ref: register({
                                        required: 'Required',
                                        pattern: {
                                            value: config.zipValidationRegex,
                                            message: "Invalid ".concat(config.labels.zip, " format"),
                                        },
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, config.labels.zip))),
                        react_1.default.createElement(error_message_1.default, { error: errors.zip }))),
                react_1.default.createElement(discount_code_field_1.default, null),
                react_1.default.createElement("div", { className: 'checkout-cta-container' },
                    react_1.default.createElement("button", { className: (0, classnames_1.default)({ 'button btn-form': true }), type: 'submit', disabled: isSubmitting, onClick: validateForm },
                        isSubmitting && react_1.default.createElement("img", { style: { width: '1em', height: '1em', marginRight: '1em' }, src: imageUrls.spinner }),
                        "Continue to Payment"),
                    hasFormErrors && (react_1.default.createElement("div", { className: 'margin-top-1' },
                        react_1.default.createElement("div", { className: 'form-error-message' }, "There is an error with your input. Please fix before placing your order."))))))))));
});
